import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { logOut } from "../../store/actions/customer";
import { Link } from "react-router-dom";
import "./UserMenu.css";

class UserMenu extends Component {
  state = {
    isOpen: false,
  };

  constructor(props) {
    super(props);
    this.menuRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.menuRef.current &&
      !this.menuRef.current.contains(event.target) &&
      this.state.isOpen
    ) {
      this.setState({ isOpen: false });
    }
  };

  toggleMenu = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  closeMenu = () => {
    this.setState({ isOpen: false });
  };

  handleLogout = (e) => {
    e.preventDefault();
    this.props.logOut();
    this.closeMenu();
  };

  render() {
    const { customer } = this.props;

    if (!customer.customer) {
      return (
        <div className="user-menu-wrapper">
          <div className="auth-links">
            <Link to="/giris-yap" className="auth-link login">
              <FontAwesomeIcon icon={["fas", "sign-in-alt"]} />
              <span className="desktop-only">Giriş Yap</span>
            </Link>
            <Link to="/uye-ol" className="auth-link register">
              <FontAwesomeIcon icon={["fas", "user-plus"]} />
              <span className="desktop-only">Kayıt Ol</span>
            </Link>
          </div>
        </div>
      );
    }

    const userName = customer.customer.full_name;
    const isPremium = customer.customer.discount_enabled === true;

    return (
      <div className="user-menu-wrapper" ref={this.menuRef}>
        <button
          className="user-button"
          onClick={this.toggleMenu}
          aria-label="Kullanıcı Menüsü"
        >
          <FontAwesomeIcon icon={["fas", "user-circle"]} />
          <span className="desktop-only">
            {userName}
            {isPremium && (
              <span className="premium-badge desktop">
                <FontAwesomeIcon icon={["fas", "crown"]} />
              </span>
            )}
          </span>
          <FontAwesomeIcon
            icon={["fas", "chevron-down"]}
            className="dropdown-arrow desktop-only"
          />
        </button>

        <div className={`user-dropdown ${this.state.isOpen ? "open" : ""}`}>
          <div className="user-dropdown-header">
            <div className="user-info">
              <div className="user-avatar">
                <div className="avatar-circle">
                  <FontAwesomeIcon icon={["fas", "user"]} />
                </div>
                {isPremium && (
                  <div className="premium-crown" style={{ padding: "2px" }}>
                    <FontAwesomeIcon icon={["fas", "crown"]} />
                  </div>
                )}
              </div>

              <div className="user-details">
                <span className="user-name">{userName}</span>
                <span className="user-status">
                  {isPremium ? "Premium Üye" : "Standart Üye"}
                </span>
              </div>
            </div>
          </div>

          <div className="user-dropdown-body">
            <nav className="user-nav">
              <Link
                to="/hesabim"
                className="user-nav-item"
                onClick={this.closeMenu}
              >
                <FontAwesomeIcon icon={["fas", "user"]} />
                <span>Hesabım</span>
              </Link>

              <Link
                to="/hesabim/siparislerim"
                className="user-nav-item"
                onClick={this.closeMenu}
              >
                <FontAwesomeIcon icon={["fas", "box"]} />
                <span>Siparişlerim</span>
              </Link>

              <Link
                to="/hesabim/adreslerim"
                className="user-nav-item"
                onClick={this.closeMenu}
              >
                <FontAwesomeIcon icon={["fas", "map-marker-alt"]} />
                <span>Adreslerim</span>
              </Link>

              <Link
                to="/siparis-sorgula"
                className="user-nav-item"
                onClick={this.closeMenu}
              >
                <FontAwesomeIcon icon={["fas", "search"]} />
                <span>Sipariş Sorgula</span>
              </Link>
            </nav>
          </div>

          <div className="user-dropdown-footer">
            <button
              type="button"
              className="logout-btn"
              onClick={this.handleLogout}
            >
              <FontAwesomeIcon icon={["fas", "power-off"]} />
              <span>Çıkış Yap</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { logOut };

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);



// WEBPACK FOOTER //
// ./src/components/shared/UserMenu.js